import React from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { Illustration } from '@winnin/winnin_ui.components.illustration'

import { useTranslate } from 'lib/tolgee'

import EmptyVideosIllustration from '../../assets/images/svg/empty-videos.svg'
import './index.scss'

const NoDataAvailable = observer(({ small, title, message, icon, className }) => {
  const t = useTranslate()

  const containerClass = classNames(
    'no-data-avaliable-container',
    { 'no-video-container': icon === 'no-video' },
    { small },
    className
  )

  return (
    <div className={containerClass}>
      {!icon && <Illustration name="noData" />}
      {(icon === 'coming-soon' || icon === 'comingSoon') && <Illustration name="comingSoon" />}
      {icon === 'no-video' && <img className="illustration-no-video" src={EmptyVideosIllustration} alt="" />}

      <div className="text-container">
        <h5>
          {title
            ? title
            : t({
                defaultValue: 'Not enough data',
                key: 'NoDataAvailable-header',
              })}
        </h5>
        <p>
          {message
            ? message
            : t({
                defaultValue: 'There’s not enough data available to give you accurate information.',
                key: 'NoDataAvailable-text',
              })}
        </p>
      </div>
    </div>
  )
})

NoDataAvailable.propTypes = {}

NoDataAvailable.defaultProps = {}

NoDataAvailable.displayName = 'NoDataAvailable'

export default NoDataAvailable
